import { useQuery } from "react-query";
import type { PartnerPointsOfSellKpisDto } from "common/models/api/models/PartnerPointsOfSellKpisDto";
import { Queries } from "ui/query/queries";
import type { QueryResult } from "ui/query/react-query-overrides";
import { partnersApi } from "../api/partnersApi";

export interface UsePartnerPointOfSellParams {
    address?: string;
}

export default function usePartnerPointOfSell({ address }: UsePartnerPointOfSellParams): QueryResult<PartnerPointsOfSellKpisDto[]> {
    const safeAddress = address as string;

    return useQuery(
        [Queries.POINTS_OF_SELL, address],
        async () => {
            const res = await partnersApi.findPointsOfSellByAddress(safeAddress);
            return res.data;
        },
        { enabled: address !== undefined },
    );
}
